<template>
    <base-exit-layout @save="save('form')" class="rule" :showBottom="true">
        <template slot="title">
            <div>
                <el-icon class="iconfont el-icon-third-iframetianjia" style="font-size: 16px;"></el-icon>
                <span style="padding-left:10px;font-size: 16px;">查看作业</span>
            </div>
        </template>
        <el-card class="box-card" shadow="never">
            <el-row>
                <el-col :span="24"><span>作业要求:</span> <span v-html="homeworkRequrement"></span></el-col>
            </el-row>
            <br/>
            <el-row>
                <el-col :span="24"><span>截止时间:</span> {{homeWorkEndTime}}</el-col>
            </el-row>
        </el-card>
        <el-card class="box-card" shadow="never">
            <el-row>
                <el-col :span="24"><span>作业标题:</span> {{detailInfo.title}}</el-col>
            </el-row>
            <br/>
            <el-row>
                <el-col :span="24"><span>学生姓名:</span> {{detailInfo.studentName}}</el-col>
            </el-row>
            <br/>
            <el-row>
                <el-col :span="24"><span>更新时间:</span> {{detailInfo.updateTime}}</el-col>
            </el-row>
            <br/>
            <el-row>
                <el-col :span="24"><span>作业内容:</span> <span v-html="detailInfo.content"></span></el-col>
            </el-row>
        </el-card>
        <el-card>
            <div style="margin: 20px 0;"></div>
            <el-row>

                <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
                    <el-form-item label="打分" prop="score">
                        <el-row v-if="scoreType === 1">
                            <el-col :span="4"> <el-input type="number" v-model="dataForm.score" ></el-input></el-col>
                        </el-row>
                        <el-row v-else-if="scoreType === 2">
                            <el-col :span="4">
                                <el-select v-model="abcValue" placeholder="请选择">
                                    <el-option
                                            v-for="item in abcOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row v-else>
                            <el-col :span="4">
                                <el-select v-model="gradeValue" placeholder="请选择">
                                    <el-option
                                            v-for="item in gradeOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="添加回复" prop="comment">

                        <el-row>
                            <el-col :span="12">
                            <el-input
                                    type="textarea"
                                    placeholder="请在此添加回复"
                                    v-model="dataForm.comment"
                                    maxlength="50"
                                    :rows="5"
                                    show-word-limit
                            >
                            </el-input>
                            </el-col>
                        </el-row>

                    </el-form-item>
                </el-form>
            </el-row>


        </el-card>
    </base-exit-layout>
</template>

<script>
    import BaseExitLayout from "../../../common/BaseExitLayout";
    import {publicPath} from "../../../../../vue.config"; // ES6 Module
    export default {
        components: {
            BaseExitLayout
        },
        data() {
            return {
                title: '作业详情',
                uploadUrl: '',
                homeworkRequrement: '',
                homeWorkEndTime: '',
                scoreType: 1,
                detailInfo: {},
                dataForm: {
                    id: 0,
                    score: 0,
                    comment: ''
                },
                abcOptions: [{
                    value: 'A',
                    label: 'A'
                }, {
                    value: 'B',
                    label: 'B'
                }, {
                    value: 'C',
                    label: 'C'
                }, {
                    value: 'D',
                    label: 'D'
                }],
                abcValue: 'A',

                gradeOptions: [{
                    value: '优秀',
                    label: '优秀'
                }, {
                    value: '良好',
                    label: '良好'
                }, {
                    value: '中等',
                    label: '中等'
                }, {
                    value: '及格',
                    label: '及格'
                }, {
                    value: '不及格',
                    label: '不及格'
                }],
                gradeValue: '优秀',

                dataRule: {

                }
            }
        },
        mounted() {

            //  this.serverUrl: '', // 服务器统一请求接口路径
        },
        created() {
            let id = this.$route.query.id;
            this.dataForm.id = id;
           // this.dataForm.homework_id = id
          //  this.init(id)
            this.studentHomeworkInfo(id)
        },
        methods: {
            homeworkInfo(id) {
                this.visible = true
                // this.title = !this.dataForm.id ? '新增备课模板'
                this.uploadUrl = this.$http.adornUrl(`/sys/oss/upload?token=${this.$cookie.get('token')}`)
                // this.$refs['dataForm'].resetFields()
                //   if (this.dataForm.id) {
                this.$http({
                    url: this.$http.adornUrl(`/business/lessonhomework/info/${id}`),
                    method: 'get',
                    params: this.$http.adornParams()
                }).then(({data}) => {

                    if (data && data.code === 0) {
                        this.homeworkRequrement = data.data.requirement
                        this.homeWorkEndTime = data.data.endTime
                        this.scoreType = data.data.scoreType
                        // this.dataForm.name = data.lessonTemplate.name
                        // this.dataForm.content = data.lessonTemplate.content
                        // this.ueContent = this.dataForm.content
                         if (this.scoreType === 2) {
                             this.abcValue = this.dataForm.score
                         }
                        if (this.scoreType === 3) {
                            this.gradeValue = this.dataForm.score
                        }
                    }
                })
                //   }
            },
            studentHomeworkInfo(id) {
                // this.$refs['dataForm'].resetFields()
                // if (this.dataForm.id) {
                this.$http({
                    url: this.$http.adornUrl(`/business/studenthomework/info/${id}`),
                    method: 'get',
                    params: this.$http.adornParams()
                }).then(({data}) => {
                    if (data && data.code === 0 && data.data !== null) {
                         this.dataForm.score = data.data.score
                         this.dataForm.comment = data.data.comment
                        // this.ueContent = this.dataForm.content
                        // this.dataForm.id = data.data.id
                           this.detailInfo = data.data
                          this.homeworkInfo(this.detailInfo.homeworkId)


                    }
                })
                //   }
            },
            save() {
                this.dataFormSubmit()
            },
            // 表单提交
            dataFormSubmit() {
                if (this.scoreType === 2) {
                    this.dataForm.score = this.abcValue
                }
                if (this.scoreType === 3) {
                    this.dataForm.score = this.gradeValue
                }
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: this.$http.adornUrl(`/business/studenthomework/${!this.dataForm.id ? 'save' : 'update'}`),
                            method: 'post',
                            data: this.$http.adornData({
                                'id': this.dataForm.id || undefined,
                                'score': this.dataForm.score,
                                'comment': this.dataForm.comment,
                            })
                        }).then(({data}) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false
                                        this.$router.go(-1)
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            }

        }
    }
</script>
<style>

</style>
